// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
export default zIndex;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/zIndex.js
// module id = 1775
// module chunks = 25